/* Keep the native picker and product form intact. Only supporting blocks move;
   their original DOM positions are restored when the desktop layout returns. */
if (!customElements.get('divine-mobile-options')) {
  customElements.define('divine-mobile-options', class extends HTMLElement {
    connectedCallback() {
      if (this.active) return;
      this.info = this.closest('.product__info-container');
      this.product = this.closest('product-info');
      if (!this.info || !this.product || typeof window.matchMedia !== 'function') return;
      this.active = true;
      this.positions = [];
      this.media = window.matchMedia('(max-width: 749px)');
      this.onLayout = () => this.applyLayout();
      this.media.addEventListener?.('change', this.onLayout);
      this.applyLayout();
    }

    disconnectedCallback() {
      this.active = false;
      this.media?.removeEventListener?.('change', this.onLayout);
      this.restoreLayout();
    }

    remember(node) {
      const marker = document.createComment('Original product block position');
      node.before(marker);
      this.positions.push({ node, marker });
    }

    restoreLayout() {
      for (const { node, marker } of this.positions || []) {
        if (marker.parentNode) marker.replaceWith(node);
      }
      this.positions = [];
      if (this.info) this.info.removeAttribute('data-mobile-options');
      this.dataset.mobileActive = 'false';
      this.hidden = true;
    }

    applyLayout() {
      const picker = this.info.querySelector('variant-selects');
      if (!this.media.matches || !picker) { this.restoreLayout(); return; }
      if (this.dataset.mobileActive === 'true') return;
      const children = Array.from(this.info.children);
      const purchase = children.find(node => node.querySelector('product-form'));
      // If an owner removes purchase controls, leave their custom block order alone.
      if (!purchase) return;
      const details = children.filter(node => node.matches(
        '.product__text, .rating-wrapper, .rating-count, .dd-pdp-benefits, .dd-pdp-facts'
      ) || (node.matches('.shopify-app-block') && node.querySelector('.jdgm-preview-badge, .jdgm-prev-badge')));
      let after = purchase;
      for (const node of details) {
        this.remember(node);
        after.after(node);
        after = node;
      }
      const fit = children.find(node => node.matches('.dd-pdp-fit'));
      if (fit && fit.previousElementSibling !== picker) { this.remember(fit); picker.after(fit); }
      this.info.setAttribute('data-mobile-options', 'true');
      this.dataset.mobileActive = 'true';
      this.hidden = true;
    }
  });
}
